import { storyblokEditable } from "@storyblok/react";
import Image from "next/image";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Container } from "../layout/container";
import Typography from "../ui/typography";
import { LogoBannerStoryblok } from "@/types/sb-component-types";
export const LogoBanner = ({
  blok
}: {
  blok: LogoBannerStoryblok;
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    amount: 0.3
  });
  return <motion.section ref={ref} {...storyblokEditable(blok)} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {
    opacity: 0,
    y: 50
  }} initial={{
    opacity: 0,
    y: 50
  }} transition={{
    duration: 0.5
  }} data-sentry-element="unknown" data-sentry-component="LogoBanner" data-sentry-source-file="LogoBanner.tsx">
      <Container data-sentry-element="Container" data-sentry-source-file="LogoBanner.tsx">
        <div className={`rounded-lg px-7 py-12 sm:py-24 ${blok.background === "dark" ? "bg-slate-100" : ""}`}>
          {blok.title && <Typography className="mb-6 text-center text-3xl font-bold md:text-4xl" variant="h2">
              {blok.title}
            </Typography>}
          {blok.description && <Typography className="mb-12 text-center text-slate-600" variant="p">
              {blok.description}
            </Typography>}
          <div className="flex flex-wrap items-center justify-center gap-12 sm:gap-16">
            {blok.logos?.map((logo, index) => <motion.div key={logo?.filename} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 20
          }} className="w-3/4 px-4 sm:w-1/3 md:w-1/4 lg:w-1/5" initial={{
            opacity: 0,
            y: 20
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }}>
                <div className="group relative">
                  <Image alt={logo.alt || "Brand logo"} className="h-16 w-full object-contain transition-all duration-300 group-hover:scale-110 sm:h-20" height={100} src={logo?.filename} width={200} />
                </div>
              </motion.div>)}
          </div>
        </div>
      </Container>
    </motion.section>;
};